import { Observable, of } from 'rxjs';
import {
  AuthAccessTokenDetails,
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  LoginOAuthResponse,
  SwapAuthForAccessTokens
} from '../../../models';
import { PostWithCredentialsFacadeService } from '../login-remember-me-facade-service/post-with-credentials-facade.service';

export const isUserNamePasswordRequired = (
  response:
    | LoginAuthWithCredentialsResponse
    | SwapAuthForAccessTokens
    | AuthAccessTokenDetails,
  loginOAuthParams: LoginOAuthParams
): boolean => {
  return (
    'status' in response &&
    response.status === loginOAuthParams.oauthConfig.USERNAME_PASSWORD_REQUIRED
  );
};

export const isCompletedStatus = (
  response: LoginAuthWithCredentialsResponse | SwapAuthForAccessTokens,
  loginOAuthParams: LoginOAuthParams
): boolean => {
  return !!(
    'status' in response &&
    response.status &&
    response.status === loginOAuthParams.oauthConfig.COMPLETED
  );
};

export const isRememberDeviceDetailsStatus = (
  response: LoginAuthWithCredentialsResponse,
  loginOAuthParams: LoginOAuthParams
): boolean => {
  return !!(
    response.status === loginOAuthParams.oauthConfig.REMEMBERED_DEVICE_DETAILS
  );
};

export const getResponseId = (response: LoginOAuthResponse): string => {
  return response.id ? response.id : '';
};

export const isRequestInputHasProperties = (
  requestInput: ILoginUserNamePasswordInput
): boolean => {
  return !!(requestInput.userName && requestInput.password);
};

export const returnAuthorizationResponseCode = (
  response: LoginAuthWithCredentialsResponse
): string => {
  return response.authorizeResponse ? response.authorizeResponse.code : '';
};

export const checkRequestInput = (
  loginOAuthParams: LoginOAuthParams,
  response: LoginAuthWithCredentialsResponse | SwapAuthForAccessTokens,
  postWithCredentialsFacade: PostWithCredentialsFacadeService,
  requestInput: ILoginUserNamePasswordInput
): Observable<
  LoginAuthWithCredentialsResponse | AuthAccessTokenDetails | string | boolean
> => {
  if (isRequestInputHasProperties(requestInput)) {
    return postWithCredentialsFacade.postWithCredFlow(
      loginOAuthParams,
      requestInput
    );
  } else {
    return of(response);
  }
};

export const returnTransformTokenDetails = (
  response: SwapAuthForAccessTokens,
  postWithCredentialsFacade: PostWithCredentialsFacadeService
): Observable<AuthAccessTokenDetails> => {
  const authAccessTokenDetails: AuthAccessTokenDetails =
    transformSwapAuthTokenDetails(response);
  if (postWithCredentialsFacade.encyToken && postWithCredentialsFacade.uid) {
    return of({
      ...authAccessTokenDetails,
      encyToken: postWithCredentialsFacade.encyToken,
      uid: postWithCredentialsFacade.uid
    });
  } else {
    return of(authAccessTokenDetails);
  }
};

export const transformSwapAuthTokenDetails = (
  response: SwapAuthForAccessTokens
): AuthAccessTokenDetails => {
  const currentTime = new Date().getTime();
  return {
    access_token: response.access_token ?? '',
    expires_in: response.expires_in ?? 0,
    token_issued_time: currentTime
  };
};

export const checkRequestIsDefined = (
  requestInput: ILoginUserNamePasswordInput | undefined
): ILoginUserNamePasswordInput => {
  return requestInput ?? ({} as ILoginUserNamePasswordInput);
};
